import { Component, inject, input } from '@angular/core';
import { Media } from '@app/models/media.model';
import { CardStyles, HeadingType, Illustration } from '@app/models/global.model';
import { TextComponent } from '@app/components/text/text.component';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { IllustrationComponent } from '@app/components/illustration/illustration.component';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { mobiIcon } from '@mobi/rwc-utils-icons-jslib';
import { HeadingSelectComponent } from '@app/components/heading-select/heading-select.component';
import { BreakpointService } from '@app/services/breakpoint.service';

@Component({
  selector: 'mobi-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  imports: [
    ComponentSharedModule,
    TextComponent,
    MobiUiIconComponent,
    IllustrationComponent,
    HeadingSelectComponent,
  ],
  standalone: true,
})
export class CardComponent {
  readonly cardImage = input<Media>();
  readonly cardIllustration = input<Illustration>();
  readonly cardTitle = input<string>();
  readonly cardText = input<string>();
  readonly cardStyle = input<CardStyles>('icon');
  readonly cardIcon = input<mobiIcon>();
  readonly cardNumber = input<number>();
  readonly cardTotal = input<number>();
  readonly cardTitleSize = input<HeadingType>();

  breakpoint = inject(BreakpointService);
}
